module.exports = __webpack_public_path__ + "static/assets/0147c64b3d50cf2d2c00f8191a5e1be4.png";